const mutations = {
  SET_JOB_LIST_FILTERS(state, payload) {
    const safe = payload || {};
    const channels = Array.isArray(safe.channels) ? safe.channels : [];
    const tags = safe.tags || {};
    const contact = Array.isArray(tags.contact) ? tags.contact : [];
    const employer = Array.isArray(tags.employer) ? tags.employer : [];
    const attendance = Array.isArray(tags.attendance) ? tags.attendance : [];
    const vis = safe.tagVisibility || {};
    state.jobList = {
      channels: channels.map((v) => String(v)).filter(Boolean),
      tags: {
        contact: contact.map((v) => Number(v)).filter((n) => !Number.isNaN(n)),
        employer: employer
          .map((v) => Number(v))
          .filter((n) => !Number.isNaN(n)),
        attendance: attendance
          .map((v) => Number(v))
          .filter((n) => !Number.isNaN(n)),
      },
      tagVisibility: {
        attendance: vis.attendance !== false,
        contact: vis.contact !== false,
        employer: vis.employer !== false,
      },
    };
  },
  CLEAR_JOB_LIST_FILTERS(state) {
    state.jobList = {
      channels: ['whatsapp', 'voice', 'chat', 'instagram'],
      tags: { contact: [], employer: [], attendance: [] },
      tagVisibility: { attendance: true, contact: true, employer: true },
    };
  },
};

export default mutations;
